import { Button, Copy } from '@grubhubprod/gh-cookbook-react';
import React from 'react';

const GROUP_ORDERS_HREF =
  'https://corporate.grubhub.com/resource/how-to-place-a-group-order-admin/?page=Resource+-+How+to+place+a+group+order+admin';

export function GroupOrdersAction(): JSX.Element {
  return (
    <Button
      variant="secondary"
      buttonSize="medium"
      block
      target="_blank"
      as="a"
      href={GROUP_ORDERS_HREF}
    >
      <Copy
        variant="body"
        textAlign="center"
        color="interactive"
        display="block"
      >
        Learn more
      </Copy>
    </Button>
  );
}
